
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.189 12.687c-.306-.305-.421-.152-.49-.084-1.759 1.76-3.321 6.006-2.495 5.591 3.006-1.51 3.507-1.06 5.267-2.82.068-.068.225-.18-.09-.494L5.19 12.687z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M14.675 12.662c-.08-.254.087-.376.157-.452C18.716 8.017 21.185 2.43 19.356.6c-1.82-1.819-7.235.722-11.427 4.578a.564.564 0 01-.539.16l-1.306-.311c-.362-.086-.875.059-1.138.322L.153 10.142c-.264.263-.178.526.19.584l3.467.545c.368.058.885-.11 1.148-.374 0 0 .18-.18.359 0l3.778 3.778c.188.188.008.366.008.366-.264.264-.432.781-.374 1.15l.545 3.466c.058.368.32.454.584.19l4.793-4.793c.263-.263.409-.776.322-1.138l-.298-1.254zm-1.073-6.191a2.078 2.078 0 112.939-2.94 2.078 2.078 0 01-2.94 2.94z","fill":"#E2E8F0"}})])
          )
        }
      }
    